import { getDemoFileUrl } from './runtime'

const YEAR = new Date().getFullYear()
const AVATAR = 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'

function pad(value) {
  return String(value).padStart(2, '0')
}

function dateOf(month, day = 15) {
  return `${YEAR}-${pad(month)}-${pad(day)}`
}

function datetimeOf(month, day = 15, hour = 9, minute = 0) {
  return `${dateOf(month, day)} ${pad(hour)}:${pad(minute)}:00`
}

function buildAdmins() {
  return [
    { id: 1, username: 'admin', password: 'admin', name: '系统管理员', phone: '13800000001', email: 'admin@demo.local', avatar: AVATAR, role: 'ADMIN' },
    { id: 2, username: 'user', password: 'user', name: '能源分析员', phone: '13800000002', email: 'user@demo.local', avatar: AVATAR, role: 'USER' },
    { id: 3, username: 'wangli', password: '123456', name: '王莉', phone: '13800000004', email: 'wangli@demo.local', avatar: AVATAR, role: 'USER' },
    { id: 4, username: 'zhanghao', password: '123456', name: '张浩', phone: '13800000005', email: 'zhanghao@demo.local', avatar: AVATAR, role: 'USER' },
    { id: 5, username: 'liuyang', password: '123456', name: '刘洋', phone: '13800000006', email: 'liuyang@demo.local', avatar: AVATAR, role: 'USER' },
    { id: 6, username: 'qa_admin', password: '123456', name: '质控管理员', phone: '13800000007', email: 'qa@demo.local', avatar: AVATAR, role: 'ADMIN' },
    { id: 7, username: 'energy_pm', password: '123456', name: '能源项目经理', phone: '13800000008', email: 'pm@demo.local', avatar: AVATAR, role: 'ADMIN' }
  ]
}

function buildEnergyEntities() {
  return [
    { id: 1, entityName: '生产车间A', entityType: 1, sortOrder: 1, description: '主要生产车间', createdTime: datetimeOf(1, 5) },
    { id: 2, entityName: '生产车间B', entityType: 1, sortOrder: 2, description: '辅助生产车间', createdTime: datetimeOf(1, 6) },
    { id: 3, entityName: '生产车间C', entityType: 1, sortOrder: 3, description: '第三生产车间', createdTime: datetimeOf(1, 7) },
    { id: 4, entityName: '锅炉房', entityType: 1, sortOrder: 4, description: '供热锅炉房', createdTime: datetimeOf(1, 8) },
    { id: 5, entityName: '辅助系统', entityType: 1, sortOrder: 5, description: '辅助生产系统', createdTime: datetimeOf(1, 9) },
    { id: 6, entityName: '办公区域', entityType: 1, sortOrder: 6, description: '办公楼区域', createdTime: datetimeOf(1, 10) },
    { id: 7, entityName: '产品线A-钢铁冶炼', entityType: 2, sortOrder: 1, description: '钢铁冶炼产品线', createdTime: datetimeOf(1, 11) },
    { id: 8, entityName: '产品线B-化工制品', entityType: 2, sortOrder: 2, description: '化工制品产品线', createdTime: datetimeOf(1, 12) },
    { id: 9, entityName: '产品线C-机械加工', entityType: 2, sortOrder: 3, description: '机械加工产品线', createdTime: datetimeOf(1, 13) },
    { id: 10, entityName: '产品线D-电子元件', entityType: 2, sortOrder: 4, description: '电子元件产品线', createdTime: datetimeOf(1, 14) },
    { id: 11, entityName: '产品线E-纺织品', entityType: 2, sortOrder: 5, description: '纺织品产品线', createdTime: datetimeOf(1, 15) },
    { id: 12, entityName: '高强度钢板', entityType: 2, sortOrder: 6, description: '高强度钢板产品', createdTime: datetimeOf(1, 16) },
    { id: 13, entityName: '热轧卷板', entityType: 2, sortOrder: 7, description: '热轧卷板产品', createdTime: datetimeOf(1, 17) },
    { id: 14, entityName: '冷轧钢带', entityType: 2, sortOrder: 8, description: '冷轧钢带产品', createdTime: datetimeOf(1, 18) },
    { id: 15, entityName: '高炉A', entityType: 3, sortOrder: 1, description: '1号高炉设备', createdTime: datetimeOf(1, 19) },
    { id: 16, entityName: '转炉B', entityType: 3, sortOrder: 2, description: '2号转炉设备', createdTime: datetimeOf(1, 20) },
    { id: 17, entityName: '轧机C', entityType: 3, sortOrder: 3, description: '3号轧机设备', createdTime: datetimeOf(1, 21) },
    { id: 18, entityName: '锅炉D', entityType: 3, sortOrder: 4, description: '4号锅炉设备', createdTime: datetimeOf(1, 22) },
    { id: 19, entityName: '空压机E', entityType: 3, sortOrder: 5, description: '5号空压机设备', createdTime: datetimeOf(1, 23) },
    { id: 20, entityName: '冷却塔F', entityType: 3, sortOrder: 6, description: '6号冷却塔设备', createdTime: datetimeOf(1, 24) },
    { id: 21, entityName: '工序1', entityType: 4, sortOrder: 1, description: '工序1', createdTime: datetimeOf(1, 25) },
    { id: 22, entityName: '工序2', entityType: 4, sortOrder: 2, description: '工序2', createdTime: datetimeOf(1, 26) },
    { id: 23, entityName: '工序3', entityType: 4, sortOrder: 3, description: '工序3', createdTime: datetimeOf(1, 27) },
    { id: 24, entityName: '工序4', entityType: 4, sortOrder: 4, description: '固定燃烧工序', createdTime: datetimeOf(1, 28) },
    { id: 25, entityName: '工序5', entityType: 4, sortOrder: 5, description: '工序5', createdTime: datetimeOf(1, 29) },
    { id: 26, entityName: '工序6', entityType: 4, sortOrder: 6, description: '工序6', createdTime: datetimeOf(1, 30) }
  ]
}

function buildEnergyTypes() {
  return [
    { id: 1, typeName: '电力', typeCode: 'electricity', unit: 'kWh', conversionFactor: 0.1229, carbonFactor: 0.5703, status: 1 },
    { id: 2, typeName: '天然气', typeCode: 'natural_gas', unit: 'm³', conversionFactor: 1.33, carbonFactor: 2.1622, status: 1 },
    { id: 3, typeName: '柴油', typeCode: 'diesel', unit: 'L', conversionFactor: 1.4571, carbonFactor: 2.593, status: 1 },
    { id: 4, typeName: '汽油', typeCode: 'gasoline', unit: 'L', conversionFactor: 1.4714, carbonFactor: 2.253, status: 1 },
    { id: 5, typeName: '液化天然气', typeCode: 'lng', unit: 't', conversionFactor: 1.7572, carbonFactor: 3.101, status: 1 }
  ]
}

function buildEnergyConsumptions(entities, types) {
  const entityMap = Object.fromEntries(entities.map(item => [item.id, item]))
  const typeMap = Object.fromEntries(types.map(item => [item.id, item]))
  const ratios = [0.074, 0.076, 0.079, 0.082, 0.084, 0.085, 0.087, 0.088, 0.089, 0.091, 0.092, 0.093]
  const plans = [
    { entityId: 1, energyTypeId: 1, base: 420000, price: 0.82 },
    { entityId: 1, energyTypeId: 2, base: 82000, price: 3.65 },
    { entityId: 2, energyTypeId: 1, base: 360000, price: 0.80 },
    { entityId: 2, energyTypeId: 2, base: 68000, price: 3.58 },
    { entityId: 3, energyTypeId: 1, base: 280000, price: 0.81 },
    { entityId: 3, energyTypeId: 3, base: 32000, price: 6.85 },
    { entityId: 4, energyTypeId: 1, base: 120000, price: 0.84 },
    { entityId: 4, energyTypeId: 2, base: 48000, price: 3.60 },
    { entityId: 5, energyTypeId: 3, base: 18000, price: 6.95 },
    { entityId: 5, energyTypeId: 4, base: 12000, price: 7.25 },
    { entityId: 6, energyTypeId: 1, base: 210000, price: 0.83 },
    { entityId: 7, energyTypeId: 1, base: 195000, price: 0.83 },
    { entityId: 7, energyTypeId: 2, base: 72000, price: 3.68 },
    { entityId: 8, energyTypeId: 1, base: 160000, price: 0.84 },
    { entityId: 8, energyTypeId: 2, base: 43000, price: 3.72 },
    { entityId: 9, energyTypeId: 1, base: 148000, price: 0.85 },
    { entityId: 9, energyTypeId: 3, base: 18500, price: 6.92 },
    { entityId: 10, energyTypeId: 1, base: 98000, price: 0.86 },
    { entityId: 10, energyTypeId: 4, base: 14600, price: 7.18 },
    { entityId: 11, energyTypeId: 2, base: 52000, price: 3.62 },
    { entityId: 11, energyTypeId: 5, base: 42, price: 4380 },
    { entityId: 12, energyTypeId: 1, base: 87000, price: 0.82 },
    { entityId: 13, energyTypeId: 1, base: 83000, price: 0.81 },
    { entityId: 14, energyTypeId: 1, base: 76000, price: 0.81 },
    { entityId: 15, energyTypeId: 2, base: 68000, price: 3.70 },
    { entityId: 16, energyTypeId: 3, base: 22500, price: 6.88 },
    { entityId: 17, energyTypeId: 1, base: 89000, price: 0.83 },
    { entityId: 18, energyTypeId: 2, base: 57000, price: 3.63 },
    { entityId: 19, energyTypeId: 1, base: 92000, price: 0.84 },
    { entityId: 20, energyTypeId: 1, base: 66000, price: 0.82 },
    { entityId: 21, energyTypeId: 1, base: 72000, price: 0.82 },
    { entityId: 22, energyTypeId: 2, base: 41000, price: 3.66 },
    { entityId: 23, energyTypeId: 1, base: 54000, price: 0.81 },
    { entityId: 24, energyTypeId: 3, base: 13000, price: 6.87 },
    { entityId: 25, energyTypeId: 4, base: 8600, price: 7.12 },
    { entityId: 26, energyTypeId: 5, base: 28, price: 4360 }
  ]

  const records = []
  let id = 1
  for (let month = 1; month <= 12; month += 1) {
    plans.forEach(plan => {
      const entity = entityMap[plan.entityId]
      const type = typeMap[plan.energyTypeId]
      const seasonal = ratios[month - 1]
      const wave = plan.entityId % 2 === 0 ? 1.03 : 0.98
      const consumptionValue = Number((plan.base * seasonal * wave).toFixed(2))
      const unitPrice = Number(plan.price.toFixed(4))
      records.push({
        id: id++,
        entityId: entity.id,
        entityName: entity.entityName,
        energyTypeId: type.id,
        energyTypeName: type.typeName,
        energyTypeUnit: type.unit,
        consumptionValue,
        unitPrice,
        totalCost: Number((consumptionValue * unitPrice).toFixed(2)),
        standardCoalValue: Number((consumptionValue * Number(type.conversionFactor)).toFixed(4)),
        carbonEmission: Number((consumptionValue * Number(type.carbonFactor)).toFixed(4)),
        consumptionDate: dateOf(month, 10 + (plan.entityId % 10))
      })
    })
  }
  return records
}

function buildProductionData() {
  const records = []
  let id = 1
  for (let month = 1; month <= 12; month += 1) {
    ;[
      { entityId: 7, entityName: '产品线A-钢铁冶炼', productionValue: 18200 + month * 260, productionUnit: '吨', outputValue: 2680 + month * 52, industrialAddedValue: 1180 + month * 24, dataType: 'product_line' },
      { entityId: 8, entityName: '产品线B-化工制品', productionValue: 13600 + month * 210, productionUnit: '吨', outputValue: 2150 + month * 41, industrialAddedValue: 930 + month * 19, dataType: 'product_line' },
      { entityId: 9, entityName: '产品线C-机械加工', productionValue: 12100 + month * 185, productionUnit: '吨', outputValue: 1890 + month * 33, industrialAddedValue: 810 + month * 16, dataType: 'product_line' },
      { entityId: 10, entityName: '产品线D-电子元件', productionValue: 9600 + month * 150, productionUnit: '吨', outputValue: 1680 + month * 28, industrialAddedValue: 760 + month * 14, dataType: 'product_line' },
      { entityId: 11, entityName: '产品线E-纺织品', productionValue: 10400 + month * 162, productionUnit: '吨', outputValue: 1520 + month * 25, industrialAddedValue: 690 + month * 12, dataType: 'product_line' },
      { entityId: 12, entityName: '高强度钢板', productionValue: 7300 + month * 118, productionUnit: '吨', outputValue: 1210 + month * 20, industrialAddedValue: 510 + month * 9, dataType: 'product_line' },
      { entityId: 13, entityName: '热轧卷板', productionValue: 6900 + month * 112, productionUnit: '吨', outputValue: 1160 + month * 18, industrialAddedValue: 485 + month * 8, dataType: 'product_line' },
      { entityId: 14, entityName: '冷轧钢带', productionValue: 6500 + month * 108, productionUnit: '吨', outputValue: 1090 + month * 17, industrialAddedValue: 460 + month * 8, dataType: 'product_line' }
    ].forEach(item => {
      records.push({ id: id++, productionDate: dateOf(month, 20), ...item })
    })
  }
  return records
}

function buildEnergyBudgets() {
  const rows = [
    ['生产车间A', 1, 1, '电力', 192000, 498000, 770000],
    ['生产车间B', 2, 2, '天然气', 171000, 445000, 675000],
    ['生产车间C', 3, 3, '柴油', 98000, 292000, 538000],
    ['锅炉房', 4, 2, '天然气', 101000, 221000, 348000],
    ['辅助系统', 5, 3, '柴油', 54000, 91000, 258000],
    ['产品线A-钢铁冶炼', 7, 1, '电力', 145000, 322000, 512000],
    ['产品线B-化工制品', 8, 2, '天然气', 99000, 239000, 381000]
  ]
  const list = []
  let id = 1
  rows.forEach(([entityName, entityId, energyTypeId, energyTypeName, energy, carbon, cost]) => {
    list.push({ id: id++, entityId, entityName, entityType: entityId <= 5 ? 1 : 2, energyTypeId, energyTypeName, budgetYear: YEAR, budgetPeriod: 'yearly', budgetType: 'energy', budgetValue: energy })
    list.push({ id: id++, entityId, entityName, entityType: entityId <= 5 ? 1 : 2, energyTypeId, energyTypeName, budgetYear: YEAR, budgetPeriod: 'yearly', budgetType: 'carbon', budgetValue: carbon })
    list.push({ id: id++, entityId, entityName, entityType: entityId <= 5 ? 1 : 2, energyTypeId, energyTypeName, budgetYear: YEAR, budgetPeriod: 'yearly', budgetType: 'cost', budgetValue: cost })
  })
  return list
}

function buildBenchmarkData() {
  const rows = [
    ['生产车间A', 1, 'department', 98, 106, 92, 112],
    ['生产车间B', 2, 'department', 104, 108, 95, 116],
    ['生产车间C', 3, 'department', 119, 112, 98, 118],
    ['锅炉房', 4, 'department', 88, 96, 82, 102],
    ['辅助系统', 5, 'department', 110, 108, 94, 115],
    ['产品线A-钢铁冶炼', 7, 'product', 82, 90, 75, 98],
    ['产品线B-化工制品', 8, 'product', 86, 93, 79, 101],
    ['产品线C-机械加工', 9, 'product', 91, 96, 84, 105],
    ['产品线D-电子元件', 10, 'product', 77, 88, 72, 95],
    ['产品线E-纺织品', 11, 'product', 95, 101, 86, 109],
    ['高强度钢板', 12, 'product', 80, 89, 74, 96],
    ['高炉A', 15, 'equipment', 88, 95, 80, 102],
    ['转炉B', 16, 'equipment', 106, 101, 92, 108],
    ['轧机C', 17, 'equipment', 84, 90, 78, 97],
    ['锅炉D', 18, 'equipment', 93, 98, 85, 104],
    ['空压机E', 19, 'equipment', 79, 87, 73, 94],
    ['冷却塔F', 20, 'equipment', 97, 102, 88, 110],
    ['工序1', 21, 'process', 102, 108, 92, 114],
    ['工序2', 22, 'process', 89, 95, 83, 103],
    ['工序3', 23, 'process', 111, 109, 96, 117],
    ['工序4', 24, 'process', 126, 118, 102, 124],
    ['工序5', 25, 'process', 94, 99, 88, 108],
    ['工序6', 26, 'process', 87, 93, 81, 100]
  ]
  return rows.map((row, index) => ({
    id: index + 1,
    entityName: row[0],
    entityId: row[1],
    benchmarkType: row[2],
    assessmentDate: `${YEAR}-12-31`,
    enterpriseValue: row[3],
    industryAverage: row[4],
    advancedValue: row[5],
    nationalLimit: row[6],
    status: row[3] <= row[5] ? '优秀' : row[3] <= row[4] ? '良好' : row[3] <= row[6] ? '达标' : '不达标'
  }))
}

function buildNotices() {
  return [
    { id: 1, title: '年度节能目标发布', content: '本年度围绕电力削峰、天然气效率优化和碳配额精细管理开展工作。', time: datetimeOf(1, 3, 10), user: '系统管理员' },
    { id: 2, title: '月度预算执行提醒', content: '各部门请于每月25日前完成预算偏差说明与整改措施填报。', time: datetimeOf(2, 5, 9, 30), user: '系统管理员' },
    { id: 3, title: '能源台账规范化通知', content: '能源消费、能源价格和产量口径须与财务月报保持一致。', time: datetimeOf(3, 8, 11), user: '能源项目经理' },
    { id: 4, title: '重点设备巡检计划', content: '空压站、热处理炉和中央冷站纳入季度重点巡检。', time: datetimeOf(4, 10, 14), user: '能源项目经理' },
    { id: 5, title: '碳核查资料归档通知', content: '供应链碳、能源消费、生产数据相关凭证需同步上传归档。', time: datetimeOf(5, 12, 14), user: '系统管理员' },
    { id: 6, title: '上半年能效对标复盘', content: '各部门结合行业先进值，提交半年度改进清单。', time: datetimeOf(6, 18, 10), user: '系统管理员' },
    { id: 7, title: '高温季节用能提醒', content: '请关注空调用电与冷站负荷，做好峰谷调度。', time: datetimeOf(7, 2, 9), user: '能源项目经理' },
    { id: 8, title: '供应链碳数据补录', content: '重点供应商需补录三季度碳排放与质量等级信息。', time: datetimeOf(8, 16, 15), user: '能源项目经理' },
    { id: 9, title: '碳配额交易窗口提示', content: '建议结合年底排放预测，滚动更新配额买卖策略。', time: datetimeOf(9, 20, 10), user: '系统管理员' },
    { id: 10, title: '四季度预算预警', content: '制造二部和物流中心预算执行率偏高，请重点关注。', time: datetimeOf(10, 9, 10), user: '系统管理员' },
    { id: 11, title: '年度核查预审安排', content: '系统管理员将于11月底前完成资料齐套性预审。', time: datetimeOf(11, 6, 13), user: '系统管理员' },
    { id: 12, title: '年度总结材料准备', content: '请各部门准备年度节能、减排、预算执行总结。', time: datetimeOf(12, 5, 9), user: '系统管理员' }
  ]
}

function buildCarbonVerifications() {
  const rows = [
    ['基础信息', '组织边界说明', 'pdf', '2.1MB', 1],
    ['基础信息', '工艺流程图', 'pdf', '1.3MB', 2],
    ['活动数据', '能源月报汇总', 'xlsx', '1.4MB', 3],
    ['活动数据', '生产数据台账', 'xlsx', '1.1MB', 4],
    ['排放因子', '排放因子清单', 'xlsx', '0.8MB', 5],
    ['原始凭证', '天然气结算单', 'pdf', '2.8MB', 6],
    ['原始凭证', '电费清单', 'pdf', '3.1MB', 7],
    ['核算过程', '核算底稿', 'xlsx', '1.9MB', 8],
    ['核查报告', '年度核查报告', 'docx', '3.8MB', 10],
    ['核查报告', '整改闭环说明', 'docx', '1.2MB', 12]
  ]
  return rows.map((row, index) => ({
    id: index + 1,
    category: row[0],
    name: row[1],
    fileName: `${row[1]}.${row[2]}`,
    fileSize: row[3],
    fileType: row[2],
    uploadTime: datetimeOf(row[4], 6 + index),
    uploadUser: index % 2 === 0 ? '系统管理员' : '能源项目经理',
    filePath: getDemoFileUrl(`${row[1]}.${row[2]}`)
  }))
}

function buildCarbonQuotaMonthly() {
  return [
    { id: 1, year: String(YEAR), month: 1, allocated: 42000, actualEmission: 35100, ccer: 800, status: '已完成', remark: '一季度平稳启动' },
    { id: 2, year: String(YEAR), month: 2, allocated: 42000, actualEmission: 36400, ccer: 800, status: '已完成', remark: '负荷上升' },
    { id: 3, year: String(YEAR), month: 3, allocated: 42000, actualEmission: 37900, ccer: 900, status: '已完成', remark: '订单增加' },
    { id: 4, year: String(YEAR), month: 4, allocated: 42000, actualEmission: 38800, ccer: 900, status: '已完成', remark: '生产高位' },
    { id: 5, year: String(YEAR), month: 5, allocated: 42000, actualEmission: 39700, ccer: 950, status: '已完成', remark: '节能措施投入' },
    { id: 6, year: String(YEAR), month: 6, allocated: 42000, actualEmission: 40300, ccer: 1000, status: '已完成', remark: '平稳' },
    { id: 7, year: String(YEAR), month: 7, allocated: 42000, actualEmission: 41400, ccer: 1100, status: '已完成', remark: '夏季负荷' },
    { id: 8, year: String(YEAR), month: 8, allocated: 42000, actualEmission: 42100, ccer: 1100, status: '已完成', remark: '接近预算' },
    { id: 9, year: String(YEAR), month: 9, allocated: 42000, actualEmission: 41800, ccer: 1200, status: '已完成', remark: '回落' },
    { id: 10, year: String(YEAR), month: 10, allocated: 42000, actualEmission: 42600, ccer: 1200, status: '已完成', remark: '旺季' },
    { id: 11, year: String(YEAR), month: 11, allocated: 42000, actualEmission: 43200, ccer: 1300, status: '已完成', remark: '压力增加' },
    { id: 12, year: String(YEAR), month: 12, allocated: 42000, actualEmission: 43700, ccer: 1400, status: '进行中', remark: '年底冲刺' }
  ]
}

function buildCarbonTransactions() {
  return [
    { id: 1, tradeDate: dateOf(1, 18), type: '买入', quantity: 8000, price: 56, amount: 44.8, remark: '年初补库' },
    { id: 2, tradeDate: dateOf(2, 26), type: '买入', quantity: 12000, price: 58, amount: 69.6, remark: '补充早期履约库存' },
    { id: 3, tradeDate: dateOf(4, 10), type: '卖出', quantity: 3500, price: 62, amount: 21.7, remark: '阶段性收益兑现' },
    { id: 4, tradeDate: dateOf(5, 21), type: '卖出', quantity: 5000, price: 63, amount: 31.5, remark: '处置阶段性富余配额' },
    { id: 5, tradeDate: dateOf(7, 3), type: '买入', quantity: 6000, price: 60, amount: 36.0, remark: '旺季前准备' },
    { id: 6, tradeDate: dateOf(8, 11), type: '买入', quantity: 8000, price: 61, amount: 48.8, remark: '应对旺季排放增长' },
    { id: 7, tradeDate: dateOf(10, 8), type: '卖出', quantity: 2600, price: 65, amount: 16.9, remark: '结构优化' },
    { id: 8, tradeDate: dateOf(11, 26), type: '卖出', quantity: 3000, price: 66, amount: 19.8, remark: '优化年度资产结构' }
  ]
}

function buildSupplyChainCarbon() {
  const rows = [
    ['华东钢材供应中心', '热轧钢卷', '620 吨', 286.4, '优', 3],
    ['华东钢材供应中心', '冷轧钢板', '410 吨', 188.6, '优', 4],
    ['华东钢材供应中心', '镀锌板材', '260 吨', 104.2, '良', 5],
    ['新材科技有限公司', '工程塑料', '210 吨', 96.8, '良', 6],
    ['新材科技有限公司', '包装辅材', '85 吨', 32.4, '良', 7],
    ['新材科技有限公司', '阻燃颗粒', '66 吨', 28.2, '中', 8],
    ['北方机加协作厂', '精密铸件', '190 吨', 122.1, '中', 9],
    ['北方机加协作厂', '机加工半成品', '135 吨', 87.6, '中', 10],
    ['绿源电子部件厂', '控制模组', '15 万套', 58.4, '优', 11],
    ['绿源电子部件厂', '传感器组件', '11 万套', 41.2, '优', 12]
  ]
  return rows.map((row, index) => ({
    id: index + 1,
    supplier: row[0],
    material: row[1],
    quantity: row[2],
    emission: row[3],
    quality: row[4],
    updateTime: dateOf(row[5], 5 + (index % 10)),
    remark: row[4] === '优' ? '数据质量较高，口径完整' : row[4] === '良' ? '整体可信，建议继续补充' : '排放偏高，需重点跟踪'
  }))
}

function buildProductCarbonFootprints() {
  return [
    {
      id: 1,
      productName: '高强度钢板系列',
      productCode: 'PCF-001',
      productionUnit: '吨',
      productionQuantity: 8200,
      accountingBoundary: '含厂内、上游、下游排放',
      accountingStartDate: `${YEAR}-01-01`,
      accountingEndDate: `${YEAR}-03-31`,
      internalEmission: 286.4,
      upstreamEmission: 91.3,
      downstreamEmission: 24.8,
      totalEmission: 402.5,
      unitCarbonFootprint: 49.09,
      upstreamDetail: '上游：铁矿粉、合金料采购运输',
      downstreamDetail: '下游：仓储周转、区域配送',
      remark: '重点订单产品线台账'
    },
    {
      id: 2,
      productName: '化工制品复合料',
      productCode: 'PCF-002',
      productionUnit: '吨',
      productionQuantity: 5600,
      accountingBoundary: '含厂内、上游、下游排放',
      accountingStartDate: `${YEAR}-04-01`,
      accountingEndDate: `${YEAR}-06-30`,
      internalEmission: 198.6,
      upstreamEmission: 76.4,
      downstreamEmission: 18.9,
      totalEmission: 293.9,
      unitCarbonFootprint: 52.48,
      upstreamDetail: '上游：基础化学原料、包装桶采购',
      downstreamDetail: '下游：物流运输、客户端分装',
      remark: '覆盖完整供应链口径'
    }
  ]
}

export function createDemoState() {
  const admins = buildAdmins()
  const energyEntities = buildEnergyEntities()
  const energyTypes = buildEnergyTypes()
  const energyConsumptions = buildEnergyConsumptions(energyEntities, energyTypes)
  const productionData = buildProductionData()
  const energyBudgets = buildEnergyBudgets()
  const benchmarkData = buildBenchmarkData()
  const notices = buildNotices()
  const carbonVerifications = buildCarbonVerifications()
  const carbonQuotaMonthly = buildCarbonQuotaMonthly()
  const carbonTransactions = buildCarbonTransactions()
  const supplyChainCarbon = buildSupplyChainCarbon()
  const productCarbonFootprints = buildProductCarbonFootprints()

  return {
    admins,
    energyEntities,
    energyTypes,
    energyConsumptions,
    productionData,
    energyBudgets,
    benchmarkData,
    notices,
    carbonVerifications,
    carbonQuotaMonthly,
    carbonTransactions,
    supplyChainCarbon,
    productCarbonFootprints
  }
}
